import { IconButton, Tooltip } from '@elkaso-app/web-design';
import { FiEdit3, FiEye, FiLink, FiSettings, FiTrash2, FiUsers } from 'react-icons/fi';

interface ActionsCellProps {
  locationId: number;
  locationName: string;
  onView: (locationId: number) => void;
  onEdit: (locationId: number) => void;
  onDelete: (locationId: number, locationName: string) => void;
  onManageAttributes: (locationId: number) => void;
  onViewChildren: (locationId: number) => void;
  onSetParent: (locationId: number) => void;
}

export const ActionsCell: React.FC<ActionsCellProps> = ({
  locationId,
  locationName,
  onView,
  onEdit,
  onDelete,
  onManageAttributes,
  onViewChildren,
  onSetParent,
}) => {
  return (
    <div
      style={{
        height: '100px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4px',
        gap: '2px',
        flexWrap: 'wrap',
        maxWidth: '100%',
      }}>
      {/* All Actions in a responsive grid */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '2px',
          width: '100%',
          maxWidth: '180px',
        }}>
        <Tooltip label='View'>
          <IconButton
            aria-label='View details'
            icon={<FiEye />}
            size='xs'
            colorScheme='blue'
            variant='outline'
            onClick={() => onView(locationId)}
          />
        </Tooltip>
        <Tooltip label='Edit'>
          <IconButton
            aria-label='Edit'
            icon={<FiEdit3 />}
            size='xs'
            colorScheme='green'
            variant='outline'
            onClick={() => onEdit(locationId)}
          />
        </Tooltip>
        <Tooltip label='Delete'>
          <IconButton
            aria-label='Delete'
            icon={<FiTrash2 />}
            size='xs'
            colorScheme='red'
            variant='outline'
            onClick={() => onDelete(locationId, locationName)}
          />
        </Tooltip>
        <Tooltip label='Attributes'>
          <IconButton
            aria-label='Manage Attributes'
            icon={<FiSettings />}
            size='xs'
            colorScheme='purple'
            variant='outline'
            onClick={() => onManageAttributes(locationId)}
          />
        </Tooltip>
        <Tooltip label='Children'>
          <IconButton
            aria-label='View Children'
            icon={<FiUsers />}
            size='xs'
            colorScheme='teal'
            variant='outline'
            onClick={() => onViewChildren(locationId)}
          />
        </Tooltip>
        <Tooltip label='Parent'>
          <IconButton
            aria-label='Set Parent'
            icon={<FiLink />}
            size='xs'
            colorScheme='orange'
            variant='outline'
            onClick={() => onSetParent(locationId)}
          />
        </Tooltip>
      </div>
    </div>
  );
};
